import { useContext } from './Context'
import React from 'react'
import { routesDef } from '../../../config/routes'
import { Icon, ShowIf } from '@ztechapps/webui.util'
import { useHistory } from '@ztechapps/common.hook'

export const ClearAllFilterButton = () => {
  const { resetFilter } = useContext()
  const history = useHistory()

  const hasFilter =
    resetFilter?.shapes?.hasValue ||
    resetFilter?.category?.hasValue ||
    resetFilter?.verticalSize?.hasValue ||
    resetFilter?.horizontalSize?.hasValue

  const onClick = () => {
    history.push(routesDef.ProductListPage.altPath())
  }

  return (
    <ShowIf condition={!!hasFilter}>
      <div className="mt-4">
        <button className="btn btn-danger" onClick={onClick}>
          <Icon name="minus-circle" /> Clear all filters
        </button>
      </div>
    </ShowIf>
  )
}
